module.exports = __webpack_public_path__ + "static/media/exception-emoji.02ee1922.svg";